/**
 * @module nhcmap/main
 */
import MapManager from '../shared/nhcmap/MapManager.js';
import './style.css';

/**
 * @description
 * This application is a generalized map designed to import a configuration
 * file and create a map with layers, controls, and overlays based on the
 * configuration.
 */
const products = [
  { id: 'ripCurrents', name: 'Rip Currents', checked: true },
  { id: 'currentStorms', name: 'Current Storms', checked: true }
];
// Parameters for the map manager
const params = {
  displayDropdown: false,
  autoZoom: false,
  latOffset: 0.0, // Offset to shift the map view down by 2 degrees
  lonOffset: 0.0,
  language: "en"
};

// This is the main entry point for the application.
// We wait for the browser to signal that the HTML document is ready.
document.addEventListener('DOMContentLoaded', () => {
  (async function initializeMap() {
    try {
      const mapManager = await MapManager.create(products, params);
    } catch (error) {
      console.error('Error initializing the map:', error);
    }
  })();
});
